import React, { useEffect } from "react";
import "./AboutPage.css";
import Aos from 'aos';
import 'aos/dist/aos.css';

const AboutBox = () => {
  useEffect(() => {
    Aos.init({ duration: 800, once: true, easing: "ease-in-out" });
  }, []);

  const boxData = [
    {
      icon: "icon-fire",
      title: "10",
      subtitle: "Project Completed",
      delay: "0"
    },
    {
      icon: "icon-cup",
      title: "532",
      subtitle: "Cup of Green Tea",
      delay: "100"
    },
    {
      icon: "icon-organization",
      title: "Habits",
      subtitle: "Football, Watching YouTube, Play Games",
      delay: "200"
    },
    {
      icon: "icon-badge",
      title: "35",
      subtitle: "Norminese Winner",
      delay: "300"
    },
  ];

  return (
    <div className="about__boxs grid dark:text-white">
      {boxData.map((box, index) => (
        <div
          key={index}
          className="about__box"
          data-aos="fade-up"
          data-aos-delay={box.delay}
        >
          <i className={`about__icon dark:text-[#F75A5A] ${box.icon}`}></i>
          <h3 className="about__title dark:text-white">{box.title}</h3>
          <span className="sub__title">{box.subtitle}</span>
        </div>
      ))}
    </div>
  );
};

export default AboutBox;
